import { doGet, doPost } from './common'

export const start = (breakId, stepId) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
  }

  return doPost(`/referral/start/`, payload)
}

export const complete = (breakId, stepId, stepSkipped) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
    skipped: stepSkipped,
  }

  return doPost(`/referral/complete/`, payload)
}

export const count = referralId => {
  return doGet(`/referral/${referralId}/counts`)
}

export const submit = (referralId, linkId) => {
  let payload = {
    referralId: referralId,
    linkId: linkId,
  }

  return doPost(`/referral/submit/`, payload)
}
